import { get,post} from './http'

//获取图形验证码
export const getimgcode = p => get('/api/open/code/captchImg', p)

//获取短信验证码
export const getcode = p => get('/api/open/sms/send', p)

//查询信息
export const getJindu = p => get('/api/open/getJindu', p)

export const getOrgInfoById = p => get('/api/open/getOrgInfoById', p)

//查询机构评分信息
export const getOrgScoreInfo = p => get('/api/open/getOrgScoreInfo', p)

export const getOrgScoreInfoWithNoPhoneCode = p => get('/api/open/getOrgScoreInfoWithNoPhoneCode', p)


//填写办学方向信息
export const saveBxfx = p => post('/api/open/orgScoreBxfx', p)

//填写办学条件信息
export const saveBxtj = p => post('/api/open/orgScoreBxtj', p)

//填写规范办学信息
export const saveGfbx = p => post('/api/open/orgScoreGfbx', p)

//填写场所情况信息
export const saveCsqk = p => post('/api/open/orgScoreCsqk', p)

//填写人员配置信息
export const saveRypz = p => post('/api/open/orgScoreRypz', p)

//填写社会效益信息
export const saveShxy = p => post('/api/open/orgScoreShxy', p)

// 查询区域下拉树结构
export const treeselect = p => get('/api/system/dept/treeselect', p)

export const getDeptList = p => get('/api/system/dept/getListByParentId', p)

//保存培训机构
export const saveOrgInfo = p => post('/api/open/saveOrgInfo', p)

//更新培训机构
export const updateOrgInfo = p => post('/api/open/updateOrgInfo', p)

//机构评分申诉
export const complainScore = p => post('/api/open/complainScore', p)


//查询系统参数，是否打开填报
export const getConfigByKey = p => get('/api/system/config/configKey/orgInfoOnOff', p)

export const getSysUserInfoByDeptId = p => get('/api/open/getSysUserInfoByDeptId', p)



